'use client';

import { useEffect, useState } from 'react';

const subscriptionLinkInDollars =
  'https://subscription.ultrahuman.com/purchase?price=price_1K3y7sHJQkNKZ6dacAuCcWIr';
const subscriptionLinkInRupees =
  'https://subscription.ultrahuman.com/purchase?price=price_1K3y7sHJQkNKZ6dayHLysuYZ';
const subscriptionLinkIphoneInDollars =
  'https://subscription.ultrahuman.com/subscribe?price=price_1Ic5AhHJQkNKZ6dajnzortO9';
const subscriptionLinkIphoneInRupees =
  'https://subscription.ultrahuman.com/subscribe?price=price_1Iw4u8HJQkNKZ6dahREtI9A1';
const indiaTimeZoneOffset = -5.5 * 60;

export const useBuyNowLink = () => {
  const [link, setLink] = useState(subscriptionLinkInDollars);

  useEffect(() => {
    if (new Date().getTimezoneOffset() === indiaTimeZoneOffset) {
      setLink(subscriptionLinkInRupees);
    }
  }, []);

  return link;
};

export const useBuyNowLinkIphone = () => {
  const [link, setLink] = useState(subscriptionLinkIphoneInDollars);

  useEffect(() => {
    if (new Date().getTimezoneOffset() === indiaTimeZoneOffset) {
      setLink(subscriptionLinkIphoneInRupees);
    }
  }, []);

  return link;
};
